// extracted by mini-css-extract-plugin
export default {"headerIcon":"styles-module__headerIcon___ciCRO"};